<template>
  <BannerController
    v-if="!isProviderOrg"
    :bannerContent="bannerContent"
  >
    <div :class="$style.content">
      <div :class="$style.text">
        <span v-if="!isCustomer">
          We noticed your organization is growing. First of all, congrats!
        </span>
        <span>
          Note that
          <strong>
            <span>
              adding the 11th user will require you to pick a subscription package.
            </span>
          </strong>
        </span>
      </div>
      <Button
        v-if="!isCustomer"
        :class="$style.button"
        hasOutline
        :href="pricingLink"
        target="_self"
        text="Go to Pricing"
        type="secondary"
      />
    </div>
  </BannerController>
</template>

<script>
import { Button } from '@jumpcloud/ui-components';
import {
  ItemTypeConsts,
  ItemTypeRoutes,
  LocalStorageConsts,
  StoreModuleMap,
} from 'client/util/Constants';
import { mapGetters, mapState } from 'vuex';
import BannerController from 'client/components/ViewportBanner/BannerController.vue';
import BannerType from 'client/components/ViewportBanner/BannerType';
import SystemUserApi from 'client/api/v2/SystemUserApi';

const { paymentPromptDismissed } = LocalStorageConsts;
const settingsModule = StoreModuleMap[ItemTypeConsts.settings];
const organizationsCollection = StoreModuleMap[ItemTypeConsts.organizations];

export default {
  name: 'PaymentPromptBanner',

  components: {
    Button,
    BannerController,
  },

  data() {
    return {
      numberOfUsersInOrg: 0,
    };
  },

  computed: {
    ...mapGetters(settingsModule, ['isProviderOrg']),

    ...mapState(settingsModule, [
      'isCustomer',
      'orgId',
    ]),

    ...mapGetters(organizationsCollection, {
      getOrganizationDetails: 'getItemDetails',
    }),

    bannerContent() {
      return new BannerType({
        bannerVisibility: () => this.numberOfUsersInOrg > 7
        && this.numberOfUsersInOrg <= 10
        && !this.isProviderOrg,
        emoji: '🌱',
        localStorageKey: paymentPromptDismissed,
        name: 'paymentPromptBanner',
      });
    },

    pricingLink() {
      return ItemTypeRoutes[ItemTypeConsts.pricing];
    },
  },

  created() {
    SystemUserApi.fetchTotalCount()
      .then((totalCount) => { this.numberOfUsersInOrg = totalCount; });
  },
};
</script>

<style module>
.content {
  align-items: flex-start;
  display: grid;
  gap: var(--jc-spacer);
  grid-template-columns: 1fr auto;
  text-align: left;
}

.text {
  padding-top: var(--jc-spacer-x-small);
}
</style>
